import { render } from "./SectionBlogComments.vue?vue&type=template&id=0b701a68&scoped=true"
import script from "./SectionBlogComments.vue?vue&type=script&lang=js"
export * from "./SectionBlogComments.vue?vue&type=script&lang=js"

import "./SectionBlogComments.vue?vue&type=style&index=0&id=0b701a68&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b701a68"]])

export default __exports__